module.exports = __webpack_public_path__ + "img/roof-repair-exterior-maintenance-06-med.7afd432a.jpg";